import { SheetClose, SheetHeader, SheetTitle } from '@e2n/ui';
import {
  UpdateTermineFormProps,
  UpdateTermineSubmitButton,
} from '@/domain/termine/features/UpdateTermin/shared';
import { UpdateTermineFormContent } from '@/domain/termine/features/UpdateTermin/shared/UpdateTermineFormContent';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function UpdateTermineDesktop({ form }: UpdateTermineFormProps) {
  const { t } = useTranslation();

  return (
    <form
      className="h-full"
      onSubmit={(e) => {
        e.preventDefault();
        form.handleSubmit();
      }}>
      <div className="flex flex-col h-full max-h-screen">
        <SheetHeader className="flex flex-row items-baseline gap-2 bg-neutrals-200 p-4">
          <SheetClose>
            <FontAwesomeIcon className="cursor-pointer" icon={faArrowLeft} />
          </SheetClose>
          <SheetTitle className="text-sm text-neutrals-800">
            {t('domain.termine.form.terminBearbeiten')}
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto">
          <UpdateTermineFormContent form={form} />
        </div>
        <hr className="h-px bg-neutrals-300 border-0" />
        <div className="flex justify-end gap-2 py-4 px-6">
          <UpdateTermineSubmitButton form={form} />
        </div>
      </div>
    </form>
  );
}
